import React, { useEffect, useState } from 'react';
import editIconWhite from '../../../../shared/assets/img/edit_icon_white.svg';
import { LabelValueCard, PageLoader } from '../../../../shared_elements';
import { Grid, Paper, Tooltip } from '@material-ui/core';
import { globalGetService, globalPostService, globalPutService } from '../../../../utils_v2/globalApiServices';
import { checkApiStatus, checkPermission, toastFlashMessage } from '../../../../utils_v2';
import { EditSidebar, InvoiceConfigCol } from '../../../../applications/contracts/Elements';
import { Row } from 'reactstrap';
import moment from 'moment';
import { displayDateFormat } from '../../../../constants';
import EditDeliveryCndCard from './EditReturnCndCard';
export default function ReturnCndCard({props}) {
  const [editModal, setEditModal] = useState({ modal: false });
  const [returnCndCard, SetReturnCndcard] = useState({});
  const [isLoading, setLoading] = useState(false);
  const [showMore, setShowMore] = useState({});
  
  useEffect(() => {
    getDeliveryCndCard();
  }, [])
  const toggleEditSideBar = (data) => {
    setEditModal({ modal: true, data: returnCndCard })
  }
  const getDeliveryCndCard = () => {
    setLoading(true);
    globalGetService(`/contracts/contract-details/${props.params.contract_slug}/`)
      .then((response) => {
        setLoading(false);
        if (checkApiStatus(response)) {
          SetReturnCndcard(response?.data.data);
        }else{
            toastFlashMessage(response?.data.message, 'error');
        }
      })
  }
  const updateDeliveryCndCard = (data, type, assetViewId) => {
    setLoading(true);
    globalPutService(`contracts/contract-details/${props.params.contract_slug}/`, data)
      .then(response => {
        if (checkApiStatus(response)) {
          setEditModal({ modal: false });
          getDeliveryCndCard();
          setLoading(false);
          toastFlashMessage('Return Condition Details Updated Successfully', 'success');
        } else {
          setLoading(false);
          toastFlashMessage('Error Occured while updating Return Condition Details', 'error');
        }
      }
      )
  }
  const toggleDescription = (id) => {
    setShowMore({
      ...showMore,
      [id]: !showMore[id],
    });
  };
  return (
    <>
    <div className="data-invoice-block" style={{marginTop:'16px'}}>
      {checkPermission('contracts','return_conditions', 'U') ?
      <h5 className="para">
        <Tooltip title="Edit Return Condition Details" placement="top">
          <img style={{ float: 'right', cursor: 'pointer' }} onClick={toggleEditSideBar} width="16" className="editIcon" src={editIconWhite} alt="img" />
        </Tooltip>
      </h5>:null}
      <Row>
          <InvoiceConfigCol
            size="2"
            title="Fit Operational Region"
            value={returnCndCard?.titan_extra_fields?.fit_operational_region||'--'}
          />
          <InvoiceConfigCol
            size="2"
            title="Livery"
            value={returnCndCard?.titan_extra_fields?.livery||'--'}
          />
          <InvoiceConfigCol
            size="2"
            title="C Check at Lease Expiry "
            value={returnCndCard?.titan_extra_fields?.c_check_at_lease_expiry||'--'}
          />
          <InvoiceConfigCol
            size="2"
            title="Must return with original engine serial numbers"
            value={returnCndCard?.titan_extra_fields?.return_with_original_sl_no||'--'}
          />
          <InvoiceConfigCol
            size="2"
            title="Redelivery Location"
            value={returnCndCard?.titan_extra_fields?.redelivery_location||'--'}
          />
          <InvoiceConfigCol
            size="2"
            title="Actual Redelivery Date"
            value={returnCndCard?.titan_extra_fields?.redelivery_date ? moment(returnCndCard?.titan_extra_fields?.redelivery_date).format(displayDateFormat) : '--'}
          />
          <InvoiceConfigCol
            size="2"
            title="Premature Redelivery"
            value={returnCndCard?.titan_extra_fields?.premature_redelivery||'--'}
          />
          <InvoiceConfigCol
            size="10"
            title="Redelivery Comment"
            value=
            {returnCndCard?.titan_extra_fields?.redelivery_comment && returnCndCard?.titan_extra_fields?.redelivery_comment?.length > 200 ? (
              <div>
                {showMore[returnCndCard?.id] && showMore[returnCndCard?.id] ? (
                  <span>
                    <span dangerouslySetInnerHTML={{ __html: returnCndCard?.titan_extra_fields?.redelivery_comment.replace(/\n/g, '<br />') }} />
                    <a href='#' style={{ color: '#f0a4ff', fontSize: '14px' }} onClick={(e) => { e.preventDefault(); toggleDescription(returnCndCard.id); }} >
                      less
                    </a>
                  </span>
                ) : (
                  <span>
                    <span dangerouslySetInnerHTML={{ __html: returnCndCard?.titan_extra_fields?.redelivery_comment.substring(0, 190).replace(/\n/g, '<br />') }} />
                    <a href='#' style={{ color: '#f0a4ff', fontSize: '14px' }} onClick={(e) => { e.preventDefault(); toggleDescription(returnCndCard.id); }} >
                      ..more
                    </a>
                  </span>
                )}
              </div>
            ) : (
              <div>
                   {returnCndCard?.titan_extra_fields?.redelivery_comment ? <span dangerouslySetInnerHTML={{ __html: returnCndCard?.titan_extra_fields?.redelivery_comment.replace(/\n/g, '<br />') }} />:'--'}
              </div>
            )} 
          />
      </Row>
    </div>
      {editModal.modal ?
        <EditSidebar
          title={`Edit Delivery Condition Details`}
          editSideBar={editModal?.modal}
          toggleEditSideBar={() => setEditModal({ modal: false })}
        >
          <EditDeliveryCndCard 
              type="edit"
              returnCndCard={returnCndCard}
              toggleEditSideBar={() => setEditModal({ modal: false })}
              updateDeliveryCndCard={(data) => updateDeliveryCndCard(data)}
          />
        </EditSidebar> : null}
        {isLoading?<PageLoader/>:null}
    </>
  )
}
